import Vue from 'vue';
import Router from 'vue-router';
import GanttTimeBoardChart from './components/GTBChart/GanttTimeBoardChart';
import GanttTimeBoardList from './components/GTBList/GanttTimeBoardList';
//import store from './store'

Vue.use(Router);

const isMobile = () => {
	return navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile|Windows Phone)/i);
}

const router = new Router({
	mode: 'history',
	routes: [
		{
			//Login
			path: '/',
		},
		{
			path: '/chart',
			name: 'GanttTimeBoardChart',
			component: GanttTimeBoardChart,
		},
		{
			path: '/list',
			name: 'GanttTimeBoardList',
			component: GanttTimeBoardList,
		},
	],
});

const isLogin = (to) => {
	return to.path === '/';
	//return (to.name === "Login") || (to.name === "SignUp");
};

router.beforeEach((to, from, next) => {
	if (isLogin(to)) {
		let name = isMobile() ? 'GanttTimeBoardList' : 'GanttTimeBoardChart';
		router.push({ 'name': name });
		return ;
	}
	
	next();
});

export default router;
